"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../context");

var _layout = require("../layout");

var _text = require("../text");

var _utils = require("../utils");

var _avatarConstants = require("./avatarConstants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledUsername = (0, _context.styledWithTheme)(_text.Text)(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color,
      fontWeight = _ref.fontWeight;
  return {
    color: theme.selectors.color(color || 'neutral70'),
    fontWeight: theme.selectors.fontWeight(fontWeight || 'regular')
  };
});
var StyledLinkRow = (0, _context.styledWithTheme)(_layout.Row, {
  shouldForwardProp: (0, _utils.filterProps)(['fontWeight'])
})(function (_ref2) {
  var theme = _ref2.theme,
      fontWeight = _ref2.fontWeight;
  return {
    fontWeight: theme.selectors.fontWeight(fontWeight)
  };
});

var AvatarUsername = function AvatarUsername(_ref3) {
  var id = _ref3.id,
      username = _ref3.username,
      fontSize = _ref3.fontSize,
      lineHeight = _ref3.lineHeight,
      fontWeight = _ref3.fontWeight,
      isUsernameClickable = _ref3.isUsernameClickable,
      newTabHiddenText = _ref3.newTabHiddenText,
      colorScheme = _ref3.colorScheme,
      linkProps = _ref3.linkProps,
      renderLink = _ref3.renderLink;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var accessibleUsername = (0, _core.jsx)(_react.default.Fragment, null, username, (0, _core.jsx)("span", {
    "aria-hidden": "true"
  }, '@'));
  var uniqueId = (0, _react.useMemo)(function () {
    return "new-tab-hidden-text-".concat((0, _utils.getUniqueId)());
  }, []);
  var textColor = colorScheme === _interfaces.AvatarColorScheme.Inverted ? _avatarConstants.INVERTED_COLOR_SCHEME.textColor : _avatarConstants.DEFAULT_COLOR_SCHEME.textColor;
  var textProps = {
    fontSize: fontSize,
    lineHeight: lineHeight,
    fontWeight: fontWeight,
    color: textColor
  };

  if (isUsernameClickable) {
    return (0, _core.jsx)(StyledLinkRow, {
      id: "".concat(_avatarConstants.COMPONENT_USERNAME_ID, "-").concat(id),
      "data-test-component": _avatarConstants.COMPONENT_USERNAME,
      fontWeight: fontWeight
    }, renderLink({
      username: username,
      accessibleUsername: accessibleUsername,
      newTabHiddenText: newTabHiddenText,
      selectors: selectors,
      lineHeight: lineHeight,
      fontSize: fontSize,
      colorScheme: colorScheme,
      id: uniqueId,
      linkProps: linkProps
    }));
  }

  return (0, _core.jsx)(StyledUsername, (0, _extends2.default)({}, textProps, {
    id: "".concat(_avatarConstants.COMPONENT_USERNAME_ID, "-").concat(id),
    "data-test-component": _avatarConstants.COMPONENT_USERNAME
  }), accessibleUsername);
};

var _default = AvatarUsername;
exports.default = _default;